import { Link } from 'react-router-dom';
import { categories } from '@/mocks/articles';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-secondary-900 text-background-50 relative overflow-hidden">
      <div className="absolute inset-0 opacity-5">
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[600px]">
          <svg viewBox="0 0 800 600" className="w-full h-full">
            <path d="M400 50 C200 100,100 200,50 300 C0 400,200 550,400 500 C600 450,750 350,700 250 C650 150,550 50,400 50Z" fill="none" stroke="currentColor" strokeWidth="1" className="text-background-50/30" />
            <path d="M400 100 C250 140,150 220,100 310 C60 390,220 510,400 470 C580 430,700 350,660 260 C620 170,530 80,400 100Z" fill="none" stroke="currentColor" strokeWidth="0.8" className="text-background-50/20" />
          </svg>
        </div>
      </div>

      <div className="relative max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-10">
          <div className="lg:col-span-2">
            <Link to="/" className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 rounded-full bg-primary-500 flex items-center justify-center">
                <i className="ri-fire-line text-sm text-background-50"></i>
              </div>
              <span className="text-xl font-bold font-heading text-background-50">51吃瓜爆料<span className="text-primary-400">.</span></span>
            </Link>
            <p className="text-secondary-200 text-sm leading-relaxed mb-6 max-w-sm">
              全网最活跃的免费吃瓜社区，每日大瓜首发曝光。专注于网红黑料大全、明星翻车与热点事件深度揭秘。
            </p>
            <div className="flex items-center gap-3">
              <a href="#" className="w-9 h-9 rounded-lg border border-secondary-600 flex items-center justify-center text-secondary-300 hover:text-background-50 hover:border-primary-400 transition-colors cursor-pointer" aria-label="微博">
                <i className="ri-weibo-line"></i>
              </a>
              <a href="#" className="w-9 h-9 rounded-lg border border-secondary-600 flex items-center justify-center text-secondary-300 hover:text-background-50 hover:border-primary-400 transition-colors cursor-pointer" aria-label="微信">
                <i className="ri-wechat-line"></i>
              </a>
              <a href="#" className="w-9 h-9 rounded-lg border border-secondary-600 flex items-center justify-center text-secondary-300 hover:text-background-50 hover:border-primary-400 transition-colors cursor-pointer" aria-label="知乎">
                <i className="ri-zhihu-line"></i>
              </a>
              <a href="#" className="w-9 h-9 rounded-lg border border-secondary-600 flex items-center justify-center text-secondary-300 hover:text-background-50 hover:border-primary-400 transition-colors cursor-pointer" aria-label="B站">
                <i className="ri-bilibili-line"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">热门分类</h4>
            <div className="flex flex-col gap-2.5">
              {categories.slice(0, 4).map((cat) => (
                <Link key={cat.id} to={`/category/${cat.slug}`} className="text-sm text-secondary-300 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer">
                  {cat.name}
                </Link>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">更多分类</h4>
            <div className="flex flex-col gap-2.5">
              {categories.slice(4).map((cat) => (
                <Link key={cat.id} to={`/category/${cat.slug}`} className="text-sm text-secondary-300 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer">
                  {cat.name}
                </Link>
              ))}
              <Link to="/about" className="text-sm text-secondary-300 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer">
                关于我们
              </Link>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">联系我们</h4>
            <div className="flex flex-col gap-2.5">
              <span className="text-sm text-secondary-300">爆料投稿：tips@chigua51.com</span>
              <span className="text-sm text-secondary-300">商务合作：biz@chigua51.com</span>
              <span className="text-sm text-secondary-300">7×24小时在线</span>
              <Link to="/about" className="text-sm text-primary-400 hover:text-primary-300 transition-colors whitespace-nowrap cursor-pointer font-medium">
                了解更多 &rarr;
              </Link>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-secondary-700 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-secondary-400">
            &copy; {currentYear} 51吃瓜爆料网 All Rights Reserved.
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-secondary-400 hover:text-secondary-200 transition-colors cursor-pointer">隐私政策</a>
            <a href="#" className="text-xs text-secondary-400 hover:text-secondary-200 transition-colors cursor-pointer">用户协议</a>
            <a href="#" className="text-xs text-secondary-400 hover:text-secondary-200 transition-colors cursor-pointer">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}